import { graphql, usePaginationFragment } from "react-relay";
import type { courseLessonComments_lesson$key } from "./__generated__/courseLessonComments_lesson.graphql";
import type { lessonCommentsQuery } from "./__generated__/lessonCommentsQuery.graphql";
import type { CommentOrdering } from "./__generated__/postCommentsQuery.graphql";
import { CommentList } from "./comment-list";

export function LessonComments({
	lesson,
	orderBy,
	setOrderBy,
}: {
	lesson: courseLessonComments_lesson$key;
	orderBy: CommentOrdering;
	setOrderBy: (orderBy: CommentOrdering) => void;
}) {
	const { data, refetch, loadNext, hasNext } = usePaginationFragment<
		lessonCommentsQuery,
		courseLessonComments_lesson$key
	>(
		graphql`
    fragment courseLessonComments_lesson on CourseClass
    @refetchable(queryName: "lessonCommentsQuery")
    @argumentDefinitions(
      	first: { type: "Int", defaultValue: 10 },
      	cursor: { type: "String" }
        orderBy: { type: "CommentOrdering", defaultValue: NEWEST }
		)
    {
      id

      ... on CourseContent {
        commentCount
        comments(first: $first, after: $cursor, orderBy: $orderBy)
        @connection(key: "lessonComments_comments")
        {
            ...commentListFragment
            edges {
                node {
                    id
                }
                cursor
            }
            pageInfo {
                hasNextPage
            }
        }
      }
    }
  `,
		lesson,
	);

	if (!data.comments) {
		return null;
	}

	return (
		<CommentList
			orderBy={orderBy}
			setOrderBy={(orderBy: CommentOrdering) => setOrderBy(orderBy)}
			loadNext={() => loadNext(3)}
			refetch={(opts: { orderBy: CommentOrdering }) =>
				refetch(opts, { fetchPolicy: "network-only" })
			}
			hasNext={hasNext}
			comments={data.comments}
			entity="lesson"
			entityId={data.id}
			commentCount={data.commentCount || 0}
		/>
	);
}
